// Utility to defer loading of non-critical scripts for better performance
// This helps reduce initial JavaScript bundle size and improves LCP/FCP

export const loadGoogleAnalytics = () => {
  // Only load if not already loaded
  if (typeof window !== 'undefined' && !window.gtag) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-93VXZL5H77';
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag(...args: any[]) {
        window.dataLayer.push(args);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', 'G-93VXZL5H77');
    };
  }
};

export const loadFacebookPixel = () => {
  // Only load if not already loaded
  if (typeof window !== 'undefined' && !window.fbq) {
    // Initialize Facebook Pixel function first
    (function(f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', undefined, undefined, undefined);

    // Initialize tracking after pixel is set up
    if (window.fbq) {
      window.fbq('init', '2111765609065690');
      window.fbq('track', 'PageView');
    }
  }
};

export const loadClarityAnalytics = () => {
  // Only load if not already loaded
  if (typeof window !== 'undefined' && !window.clarity) {
    (function(c: any, l: any, a: any, r: any, i: any, t: any, y: any) {
      c[a] = c[a] || function() {
        (c[a].q = c[a].q || []).push(arguments);
      };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "ql6hf6iyuq", undefined, undefined);
  }
};

// Load all deferred scripts after a delay to improve initial page load
export const loadDeferredScripts = () => {
  if (typeof window !== 'undefined') {
    // Use requestIdleCallback if available, otherwise setTimeout
    const scheduleLoad = (callback: () => void) => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(callback, { timeout: 2000 });
      } else {
        setTimeout(callback, 1000);
      }
    };

    // Load scripts in order of priority (analytics last)
    scheduleLoad(() => {
      loadClarityAnalytics();
      
      // Load Google Analytics after a slight delay
      setTimeout(loadGoogleAnalytics, 500);
      
      // Load Facebook Pixel last
      setTimeout(loadFacebookPixel, 1000);
    });
  }
};

// Type declarations for global objects
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
    fbq: (...args: any[]) => void;
    _fbq: any;
    clarity: (...args: any[]) => void;
  }
}